import { Component, ElementRef, inject, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ConfirmationBoxComponent } from 'src/app/shared/components/confirmation-box/confirmation-box.component';
import { TermsConditionsService } from '../../services/terms-conditions/terms-conditions.service';
import { handlePaginationChangeUtil } from 'src/app/core/services/uitls/navigation.utils';
import { Router } from '@angular/router';

@Component({
    selector: 'app-terms-conditions-list',
    templateUrl: './terms-conditions-list.component.html',
    styleUrl: './terms-conditions-list.component.scss',
    standalone: false
})
export class TermsConditionsListComponent implements OnInit {

  page: number = 1;
  page_size: number = 20;
  totalRecords: any = 0;
  config = {
    id: 'additionList',
    itemsPerPage: this.page_size,
    currentPage: this.page,
    totalItems: this.totalRecords,
  };
  services: any;
  termsConditionsList: any;
  searchValue: any;
  showSpinner: boolean = false;
  deleteDialogRef: MatDialogRef<ConfirmationBoxComponent>;

  termsConditionsService = inject(TermsConditionsService);
  router = inject(Router);
  dialog = inject(MatDialog);

  payload: { page: number; query?: string; page_size?: number } = {
    page: this.page,
    page_size: this.page_size,
    query: '',
  };
  currentItemsPerPage: number;
  @ViewChild('goUp', { static: true }) contentPage: ElementRef;

  ngOnInit(): void {
    this.getTermsAndConditionsList();
  }

  getTermsAndConditionsList() {
    this.showSpinner = true;
    this.termsConditionsService.getTermsAndConditions(this.payload).subscribe({
      next: (res) => {
        this.termsConditionsList = res.results;
        this.config.totalItems = res.count;
        this.showSpinner = false;
      },
      error: (err) => {
        console.log(err);
        this.showSpinner = false;
      },
    });
  }

  quickSearch(event) {
    this.showSpinner = true;
    this.searchValue = event;
    this.config.currentPage = 1;
    this.payload = {
      page: this.config.currentPage
    };

    if (this.searchValue) {
      this.payload['query'] = this.searchValue;
    } else if ('query' in this.payload) {
      delete this.payload['query'];
    }

    this.getTermsAndConditionsList();
  }

  showDeleteConfirmationBox(id, label, index) {
    this.deleteDialogRef = this.dialog.open(ConfirmationBoxComponent, {
      data: {
        id: id,
        index: index,
        message: `هل أنت متأكد من حذف "${label}"؟`,
      },
    });
    this.deleteDialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.deleteTermAndCondition(result);
      }
    });
  }

  deleteTermAndCondition(event) {
    this.showSpinner = true;
    this.termsConditionsService.deleteTermAndCondition(event.id).subscribe({
      next: (res) => {
        this.getTermsAndConditionsList();
      },
      error: (err) => {
        this.showSpinner = false;
      },
    });
  }

  pageChanged(event) {
    handlePaginationChangeUtil(
      this.contentPage,
      (value: boolean) => this.showSpinner = value,
      this.router,
      'page',
      event
    );
    this.config.currentPage = event;
    this.payload = {
      page: event,
      query: this.searchValue || '',
      page_size: this.payload.page_size ?? 20,
    };
    this.getTermsAndConditionsList();
  }

  changeToSpecific(event) {
    this.pageChanged(event)
  }

  pageSizeChanged(event) {
    handlePaginationChangeUtil(
      this.contentPage,
      (value: boolean) => this.showSpinner = value,
      this.router,
      'page_size',
      event
    );
    this.config.itemsPerPage = event;
    this.payload['page'] = this.config.currentPage;
    this.payload['page_size'] = event;
    this.getTermsAndConditionsList();
  }

}
